
import Rebase  from 're-base'
import firebase from 'firebase'


export const firebaseApp = firebase.initializeApp({
  apiKey: 'AIzaSyBcmIizdpTNbZgR3II3XPugQE3EGZXqDWU',
  authDomain: 'trader-exec.firebaseapp.com',
  databaseURL: 'https://trader-exec.firebaseio.com',
  storageBucket: 'trader-exec.appspot.com'
})

export const base = Rebase.createClass(firebaseApp.database())


export const colours = ['#da4242', '#0088FE', '#FFBB28', '#FF8042', '#00C49F', '#da4242', '#0088FE', '#FFBB28', '#FF8042', '#00C49F', '#da4242', '#0088FE', '#FFBB28', '#FF8042', '#00C49F', '#da4242', '#0088FE', '#FFBB28', '#FF8042', '#00C49F']

export const CScolours = ['#0088FE', '#da4242', '#9ec328']
export const debounceTime = 700

export const  statuses = [
  { label: 'Quote', value: 'quote', action_label: 'Quote', class: 'btn-info', col: 1 },
  { label: 'Confirmed', value: 'confirmed', action_label: 'Confirmed', class: 'btn-warning', col: 2 },
  { label: 'Invoiced', value: 'invoiced', action_label: 'Invoiced', class: 'btn-danger', col: 3 },
  { label: 'Paid', value: 'paid', action_label: 'Paid', class: 'btn-success', col: 4 }
]

export const  jobViews = [
  { label: 'Job', value: 'tabs-view', icon: 'icon-clipboard', action_label: 'Tabs', class: 'btn-', text: 'Place some text here', col: 1 },
  { label: 'Quote', value: 'quote-view', icon: 'icon-inbox', action_label: 'Quote', class: 'btn-', text: 'Place some text here', col: 3 },
  { label: 'Invoice', value: 'invoice-view', icon: 'icon-credit-card', action_label: 'Invoice', class: 'btn-', activeClass: 'bg-danger', text: 'Place some text here', col: 2 },
  { label: 'Receipt', value: 'receipt-view', icon: 'icon-file-text', action_label: 'graphs', class: 'btn-', text: 'Place some text here', col: 4 },
  { label: 'Report', value: 'graph-view', icon: 'icon-chart', action_label: 'graphs', class: 'btn-', text: 'Place some text here', col: 5 },
  { label: 'Edit', value: 'edit-view', icon: 'icon-edit-2', action_label: 'graphs', class: 'btn-', text: 'Place some text here', col: 5 }
]

export const stripeConfig = {
    publishableKey: 'pk_live_l49nRSzqv7w664V4qs23RTt8'
};


export const bootsrapColours = {
  primary: '#1f5887',
  success: '#7fa30c',
  info: '#6bc4ea',
  warning: '#f3812d',
  danger: '#red'
}

// _____________________

export const initalItemData = {
  a_label: "",
  b_cost: 0,
  c_sale: 0,
  zz_wanted: true
}

export const newJob = {
  formItems: {
    title: "Income Sources",
    "type": "array",
    "items": {
      "type": "object",
      "properties": {
        "a_label": { "type": "string", "title": "Name" },
        "b_cost": { "title": "Cost", "type": "number", "default": 0 },
        "c_sale": { "title": "Sale", "type": "number", "default": 0 },
        "d_quantity": { "title": "Quantity", "type": "number", "default": 1 },
        "z_extras": {
          "type": "object", "title": "Note",
          "properties": {
              "notes": {
                "type": "string", "title": "Note"
              }
            }
        }
      }
    }
  },
  formUi: {
    "items": {
      "classNames": "grouper",
      "a_label": { "ui:placeholder": "Name", "classNames": "col-sm-5", "ui:options": { "label": true } },
      "b_cost": { "classNames": "col-xs-6 col-sm-2", "ui:placeholder": "0.00", "ui:widget": "updown" },
      "c_sale": { "classNames": "col-xs-6 col-sm-2", "ui:placeholder": "0.00", "ui:widget": "updown" },
      "d_quantity": { "classNames": "col-xs-6 col-sm-1", "ui:placeholder": "1", "ui:widget": "updown" },
      "z_extras": {
        "classNames": "col-xs-12 col-sm-12",
        "ui:field": "extras" ,
      }
    }
  },
  formData: {
    a: [
      {
        a_label: "",
        b_cost: 0,
        c_sale: 0,
        d_quantity: 1
      }
    ]
  },
  tabs: ['Expenses']
}

export const admin_uid = "Y40jhlAHM4QioHJT87IaPDQ7OlX2";

export const google_analytics_tracking_id = '';
export const payment_required = true;
export const onboarding = true;
export const trial_days = 7;
export const graph_api_version = '2.5';

export const lambda_email_api = 'https://3z4k770jic.execute-api.us-west-2.amazonaws.com/prod/email';
export const contact_email = 'david@audiounderground.co';

export const facebookConfig = {
  appId: '509780036057071',
  appSecret: 'f0482a2cf04e64f673a5aa56f2bacd8d'
};

export const youtube_config = {
    key: 'AIzaSyCLgWkBr4SE46K8MEEkAfEs6ijEtB5b1v0'
};

export const send_app = {
    method: 'send',
    name: 'People Argue Just to Win',
    description: 'People Argue Just to Win',
    link: "https://trader-exec.firebaseapp.com",
    display: 'popup'
};

export const share_app = {
    method: 'share',
    href: "https://trader-exec.firebaseapp.com",
    display: 'popup'
};

export const paymentPlans = [
  {
    id: "audio_underground_bronze",
    name: "Bronze",
    price: "2"
  },
  {
    id: "audio_underground_silver",
    name: "Silver",
    price: "5"
  },
  {
    id: "audio_underground_gold",
    name: "Gold",
    price: "7"
  }
];



// WEBPACK FOOTER //
// ./src/config.js